import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const PenghasilanService = {}

PenghasilanService.getDataAll = function (token) {

    return fetch({
        url: '/ref/penghasilan',
        method: 'get',
        params: {
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

PenghasilanService.getDataByID = function (token,id) {

    return fetch({
        url: '/ref/penghasilan',
        method: 'get',
        params: {
            "id_penghasilan":id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

export default PenghasilanService;
